import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function CircularPhotoCard({ image, icon, name, position, description }) {
  return (
    <MKBox display="flex" flexDirection="column" height="100%">
      <MKBox sx={{ mt: 3 }}>
        <Grid
          container
          // borderRadius="10px"
          // border="1px solid lightgrey"
          // boxShadow="5px 5px lightgrey"
          sx={{
            border: "1px solid lightgrey",
            borderLeft: "none",
            borderRight: "none",
            borderBottom: "none",
          }}
        >
          <Grid item xs={12} lg={3} sx={{ mt: -3, ml: -3 }}>
            <MKBox width="100%" height="100%" pt={0} pb={1} px={2}>
              <MKBox
                component="img"
                src={image}
                alt={name}
                width="100%"
                borderRadius="100%"
                shadow="lg"
                sx={{ zIndex: "10" }}
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={9}>
            <MKBox
              display="flex"
              flexDirection="column"
              pt={1}
              pb={2.5}
              pr={1}
              pl={{ xs: 0, md: -10, lg: 1 }}
              lineHeight={1}
              // textAlign="justify"
              wordbreak="break-word"
              sx={{ zIndex: "10" }}
            >
              <MKTypography variant="h5">{name}</MKTypography>
              {position?.label && (
                <MKTypography
                  variant="h6"
                  color={position.color}
                  mb={1}
                  height="100%"
                  sx={{ fontWeight: "regular" }}
                >
                  {position.label}
                </MKTypography>
              )}
            </MKBox>
          </Grid>
        </Grid>
      </MKBox>
      {description && (
        <MKBox
          bgColor="light"
          display="flex"
          flexDirection="column"
          height="100%"
          pt={{ xs: 1, lg: 6 }}
          pb={2}
          pl={2}
          mt={{ sm: 0, md: -1, lg: -7 }}
          // pr={5}
          sx={{ zIndex: "-10" }}
        >
          {Array.isArray(description) ? (
            description.map((item, index) => (
              <MKBox
                display="flex"
                flexDirection="row"
                key={index}
                sx={{ textAlign: "justify" }}
                mr={2}
              >
                <MKBox>
                  <Icon sx={{ mr: 1 }} color={"info"}>
                    {icon}
                  </Icon>
                </MKBox>
                <MKTypography
                  variant="body2"
                  color="text"
                  sx={{ textAlign: "justify" }}
                  width="100%"
                >
                  {item}
                </MKTypography>
              </MKBox>
            ))
          ) : (
            <MKBox height="100%">
              <MKTypography
                variant="body2"
                color="text"
                sx={{ textAlign: "justify" }}
                width="100%"
                height="100%"
              >
                {description}
              </MKTypography>
            </MKBox>
          )}
        </MKBox>
      )}
    </MKBox>
  );
}

// Typechecking props for the HorizontalTeamCard
CircularPhotoCard.propTypes = {
  image: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  position: PropTypes.shape({
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "light",
      "text",
    ]),
    label: PropTypes.string,
  }),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

export default CircularPhotoCard;
